
import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
    mode: 'hash',
    base: process.env.BASE_URL,
    routes: [
        {
            path: '/',   // path 设置为 “/” ，默认显示该页面
            name: 'login',
            component: () =>
                import ('./views/login.vue')
        },
        {
            path: '/index',
            name: 'index',
            component: () =>
                import ('./views/index.vue')
        },
        {
            path: '/login',
            name: 'login',
            component: () =>
                import ('./views/login.vue')
        }, {
            path: '/protocol',
            name: 'protocol',
            component: () =>
                import ('./views/protocol.vue')
        }
    ]
})